import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=776ae5ce&scoped=true"
import script from "./CustomList.vue?vue&type=script&lang=js"
export * from "./CustomList.vue?vue&type=script&lang=js"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=776ae5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776ae5ce",
  null
  
)

export default component.exports